import {Box, Text, Heading} from '@chakra-ui/react';
import {Maybe, Scalars, ResponsiveImage} from '../../graphql/datocms-generated';
import {DatoImage} from '../global/datoImage';

interface BasicCardProps {
  enableAnimation?: boolean;
  image?: ResponsiveImage;
  imageTag?: string;
  text?: Maybe<Scalars['String']>;
}
export const BasicCard: React.FC<BasicCardProps> = ({
  enableAnimation = false,
  image,
  imageTag,
  text,
}) => {
  return (
    <Box as="article">
      <Box
        position="relative"
        pb={2}
        opacity={enableAnimation ? 1 : 0}
        transition="opacity .7s ease"
      >
        {image && (
          <Box borderRadius="8px" overflow="hidden" pos="relative">
            <DatoImage responsiveImage={image} />
            {imageTag && (
              <Heading
                as="span"
                position="absolute"
                right="0"
                top="0"
                background="green.300"
                p={2}
                size="h5"
              >
                {imageTag}
              </Heading>
            )}
          </Box>
        )}
        {text && <Text>{text}</Text>}
      </Box>
    </Box>
  );
};
